import dayjs from 'dayjs';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';
import { toRelativeDateNotation } from '../formatters';
import { isValidEmail } from './is-valid-email';
export class ConfigRulesValidator {
    values;
    ctx;
    rules;
    constructor(opts) {
        this.values = opts.values;
        this.ctx = opts.ctx;
        this.rules = opts.rules;
    }
    getValue(fieldName) {
        return this.values[fieldName];
    }
    getRule(ruleName) {
        return this.rules.find((rule) => rule.rule === ruleName);
    }
    getDateMethod(direction) {
        return direction === 'before' ? 'subtract' : 'add';
    }
    getDateByNotation(ruleValue) {
        const { unit, direction, amount } = toRelativeDateNotation(ruleValue);
        return dayjs()[this.getDateMethod(direction)](amount, unit);
    }
    setIssue(message, path) {
        this.ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message,
            path,
        });
    }
    required(fieldName) {
        const rule = this.getRule('required');
        if (!rule)
            return;
        const value = this.getValue(fieldName);
        const isValid = Array.isArray(value) ? value.length : value !== undefined && value !== null && value !== '';
        if (!isValid) {
            this.setIssue('Required field', [fieldName]);
        }
    }
    minRelativeDate(fieldName) {
        const rule = this.getRule('minRelativeDate');
        if (!rule)
            return;
        const value = this.getValue(fieldName);
        const date = this.getDateByNotation(rule.value);
        if (dayjs(value).isAfter(date)) {
            this.setIssue('The specified date is less than the minimum', [fieldName]);
        }
    }
    maxRelativeDate(fieldName) {
        const rule = this.getRule('maxRelativeDate');
        if (!rule)
            return;
        const value = this.getValue(fieldName);
        const date = this.getDateByNotation(rule.value);
        if (dayjs(value).isBefore(date)) {
            this.setIssue('The specified date is greater than the maximum', [fieldName]);
        }
    }
    phone(fieldName) {
        const value = this.getValue(fieldName);
        if (value && !isPossiblePhoneNumber(value)) {
            this.setIssue('Phone number is invalid', [fieldName]);
        }
    }
    email(fieldName) {
        const value = this.getValue(fieldName);
        if (value && !isValidEmail(value)) {
            this.setIssue('The specified email is not valid', [fieldName]);
        }
    }
}
//# sourceMappingURL=config-rules.validator.js.map